/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React, { useMemo } from 'react';
import { ListItemText } from '@mui/material';
import { NetworkAvailability, SpaceNetworkInfo } from '../../../shared/entities/terminal';
import { valueOrPlaceholder } from '../../../utils/StringUtils';
import { getSvNetworkAvailabilityText } from '../../../utils/SpaceVehicleUtils';

const TransportMonitoringPlatformListListItemDataDefault = (props: {
  spaceNetworkInfo: SpaceNetworkInfo;
  classes: any;
}) => {
  const { spaceNetworkInfo, classes } = props;

  const leftListItemText = useMemo(
    () => (
      <ListItemText
        data-test="space-vehicle-terminal-list-item-text__left-column"
        classes={{
          primary:
            spaceNetworkInfo.networkAvailability !== NetworkAvailability.OFFLINE
              ? spaceNetworkInfo.networkAvailability === NetworkAvailability.AVAILABLE
                ? classes.leftPrimaryActive
                : classes.leftPrimaryStandby
              : classes.leftPrimaryOffline,
          secondary: classes.leftSecondary,
          multiline: classes.leftMultiline,
        }}
        primary={
          <span data-test="space-vehicle-terminal-list-item-text__left-column__terminal-status">
            {[
              `${valueOrPlaceholder(spaceNetworkInfo.networkName)} : ${getSvNetworkAvailabilityText(spaceNetworkInfo)}`,
            ]}
          </span>
        }
        secondary={
          <span data-test="space-vehicle-terminal-list-item-text__left-column__network-beam-status">
            {`${valueOrPlaceholder(spaceNetworkInfo.networkMetricText)}`}
          </span>
        }
      />
    ),
    [spaceNetworkInfo, classes],
  );

  return <React.Fragment>{leftListItemText}</React.Fragment>;
};

export default TransportMonitoringPlatformListListItemDataDefault;
